import { colors, Modal, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import React from "react";
import { AutomaticPayment } from "../../../graphql/payments.datatypes";
import { BillingPartyMember } from "../../../graphql/billing_party.datatypes";
import ManageAutomaticPayment from "./ManageAutomaticPayment";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: "90%",
        overflowY: "auto",
        maxWidth: "95%"
    },
    container: {
        marginTop: theme.spacing(3)
    },
    actions: {
        justifyContent: "flex-end"
    },
    deleteButton: {
        color: theme.palette.white,
        backgroundColor: colors.red[600],
        "&:hover": {
            backgroundColor: colors.red[900]
        }
    },
    submitButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        "&:hover": {
            backgroundColor: colors.green[900]
        }
    }
}));

const ManageAutomaticPaymentModal = (props: {
    className?: string;
    onClose: () => void;
    onPaymentDelete: () => void;
    open: boolean;
    automaticPayment: AutomaticPayment;
    billingPartyMember: BillingPartyMember;
}) => {
    const {
        open,
        onClose,
        automaticPayment,
        onPaymentDelete,
        billingPartyMember
    } = props;
    const classes = useStyles();

    if (!open) {
        return null;
    }

    return (
        <Modal onClose={onClose} open={open}>
            <ManageAutomaticPayment
                className={clsx(classes.root)}
                onClose={onClose}
                onPaymentDelete={onPaymentDelete}
                billingPartyMember={billingPartyMember}
                automaticPayment={automaticPayment}
            />
        </Modal>
    );
};

export default ManageAutomaticPaymentModal;
